module.exports = __webpack_public_path__ + "img/772-1b87d3.png";